import React from "react";
import { Container, Row, Col, Card, ListGroup, Image } from "react-bootstrap";
import Header from './Header';
import Footer from './Footer';
import RecentPost from './RecentPost';


const VsCodeShortcuts = () => {
  return (
    <>
    <Header />
    <div className="full-div" id="blog">
    <Container fluid className="main-sec">
      <Row>
        <Col sm={2}></Col>
        <Col sm={7} className="bg-white p-4 shadow mb-3">
          <h1>Mastering VS Code: Essential Shortcut Keys for Productivity</h1>
          <span className="small text-muted"><b>Publish By:</b> CodeInputs</span>
          
          <Row className="mt-3 text-center">
            <Col md={12}>
              <Image src="/graphics/images/vscode_shortcuts.png" alt="VS Code Shortcuts" fluid />
            </Col>
          </Row>
          
          <p className="mt-4 text-dark">Visual Studio Code (VS Code) is a powerful and lightweight code editor loved by developers worldwide. One of its greatest strengths lies in its extensive support for keyboard shortcuts, allowing you to navigate, edit, and manage projects efficiently without constantly reaching for the mouse.</p>
          
          <h4>General Shortcuts</h4>
          <ul>
            <li>Ctrl + P: Quick open files</li>
            <li>Ctrl + Shift + P / F1: Open command palette</li>
            <li>Ctrl + Shift + N: Open a new window</li>
            <li>Ctrl + W: Close current editor</li>
            <li>Ctrl + K, Ctrl + W: Close all editors</li>
          </ul>
          
          <h4>File Navigation</h4>
          <ul>
            <li>Ctrl + Tab: Switch between open files</li>
            <li>Ctrl + Shift + T: Reopen closed editor</li>
            <li>Ctrl + Shift + E: Show explorer panel</li>
            <li>Ctrl + B: Toggle sidebar visibility</li>
          </ul>
          
          <h4>Editing Shortcuts</h4>
           <ul>
            <li>Ctrl + X / Ctrl + C / Ctrl + V: Cut, copy, and paste</li>
            <li>Ctrl + Shift + K: Delete entire line</li>
            <li>Alt + ↑ / ↓: Move line up or down</li>
            <li>Shift + Alt + ↓ / ↑: Duplicate line</li>
            <li>Ctrl + Enter: Insert line below</li>
            <li>Ctrl + Shift + Enter: Insert line above</li>
          </ul>
          
          <h4>Search and Replace</h4>
          <ul>
            <li>Ctrl + F: Find in file</li>
            <li>Ctrl + H: Replace in file</li>
            <li>Ctrl + Shift + F: Find in project</li>
            <li>Ctrl + Shift + H: Replace in project</li>
            <li>F3 / Shift + F3: Find next/previous occurrence</li>
          </ul>
          
          <h4>Multi-Cursor Editing</h4>
          <ul>
            <li>Ctrl + D: Select next occurrence</li>
            <li>Ctrl + Shift + L: Select all occurrences</li>
            <li>Alt + Click: Add new cursor</li>
            <li>Ctrl + Alt + ↑ / ↓: Insert cursors above/below</li>
            <li>Ctrl + Shift + Alt + Left/Right: Expand/shrink selection</li>
          </ul>
          <h4>Code Formatting and Refactoring</h4>
          <ul>
            <li>Shift + Alt + F: Format document</li>
            <li>Ctrl + Shift + I: Auto-indent lines</li>
            <li>F2: Rename symbol</li>
            <li>Ctrl + .: Quick fix suggestions</li>
            <li>Ctrl + Shift + O: Show symbols in file</li>
          </ul>
          
          <h4>Terminal Shortcuts</h4>
          <ul>
          <li><strong>Ctrl + `</strong>: Toggle terminal</li>
          <li><strong>Ctrl + Shift + `</strong>: Create new terminal</li>
          <li><strong>Ctrl + Shift + C</strong>: Copy terminal output</li>
          <li><strong>Ctrl + Shift + V</strong>: Paste in terminal</li>
          <li><strong>Ctrl + L</strong>: Clear terminal output</li>
          </ul>

          <h4>Debugging Shortcuts</h4>
          <ul>
          <li><strong>F5</strong>: Start debugging</li>
          <li><strong>Shift + F5</strong>: Stop debugging</li>
          <li><strong>F9</strong>: Toggle breakpoint</li>
          <li><strong>F10</strong>: Step over</li>
          <li><strong>F11</strong>: Step into</li>
          <li><strong>Shift + F11</strong>: Step out</li>
          </ul>

          <h4>Git Integration</h4>
          <ul>
          <li><strong>Ctrl + Shift + G</strong>: Open source control panel</li>
          <li><strong>Ctrl + Enter</strong>: Commit changes</li>
          <li><strong>Ctrl + Shift + P</strong>, then type <strong>git</strong> to see Git commands</li>
          </ul>
          
          <h3>Conclusion</h3>
          <p className="mt-4 text-dark">Mastering these shortcuts can significantly enhance your efficiency in VS Code. Start by incorporating a few into your workflow, and soon they’ll become second nature. Happy coding!</p>
        </Col>
        
        <Col sm={3}>
          <Card className="mb-3 shadow">
            <Card.Body>
              <h4 className="mt-4 head-color">Recent Post</h4>
              <RecentPost />
            </Card.Body>
          </Card>

          <Card className="shadow">
            <Card.Body>
              <h4 className="mt-4 head-color">Recent Comment</h4>
              <p className="text-muted">No Comments to Show</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
    </div>
    <Footer />
    </>
  );
};

export default VsCodeShortcuts;